import { render, staticRenderFns } from "./PrivilegeOrder.vue?vue&type=template&id=11b39ac8&"
import script from "./PrivilegeOrder.vue?vue&type=script&lang=js&"
export * from "./PrivilegeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports